"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcLocationBuilderPosition = void 0;
var bc_location_builder_constants_1 = require("./bc-location-builder-constants");
var bc_location_builder_constants_2 = require("./bc-location-builder-constants");
var bc_location_builder_constants_3 = require("./bc-location-builder-constants");
var common_constants_1 = require("../constants/common-constants");
var BcLocationBuilderPosition = (function () {
    function BcLocationBuilderPosition() {
    }
    BcLocationBuilderPosition.prototype.evaluateArrowPosition = function (position, arrow, targetOffset) {
        switch (position) {
            case bc_location_builder_constants_2.BC_LOCATION_BUILDER_BOTTOM: {
                this.setPosititonArrow(bc_location_builder_constants_2.BC_LOCATION_BUILDER_BOTTOM, arrow, targetOffset);
                break;
            }
            case bc_location_builder_constants_3.BC_LOCATION_BUILDER__RIGHT: {
                this.setPosititonArrow(bc_location_builder_constants_3.BC_LOCATION_BUILDER__RIGHT, arrow, targetOffset);
                break;
            }
            case bc_location_builder_constants_2.BC_LOCATION_BUILDER_LEFT: {
                this.setPosititonArrow(bc_location_builder_constants_2.BC_LOCATION_BUILDER_LEFT, arrow, targetOffset);
                break;
            }
            default: {
                this.setPosititonArrow(bc_location_builder_constants_3.BC_LOCATION_BUILDER_TOP, arrow, targetOffset);
                break;
            }
        }
    };
    BcLocationBuilderPosition.prototype.setPosititonArrow = function (position, arrow, targetOffset) {
        arrow.classList.remove(arrow.classList.item(1));
        arrow.classList.add(arrow.classList.item(0) + '--' + position);
        switch (position) {
            case bc_location_builder_constants_2.BC_LOCATION_BUILDER_BOTTOM: {
                arrow['style'].left = targetOffset.width / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2 - bc_location_builder_constants_1.BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].top = targetOffset.height + 'px';
                break;
            }
            case bc_location_builder_constants_3.BC_LOCATION_BUILDER__RIGHT: {
                arrow['style'].top = targetOffset.height / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2 - bc_location_builder_constants_1.BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].left = targetOffset.width + 'px';
                break;
            }
            case bc_location_builder_constants_2.BC_LOCATION_BUILDER_LEFT: {
                arrow['style'].top = targetOffset.height / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2 - bc_location_builder_constants_1.BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].left = -bc_location_builder_constants_1.BC_LOCATION_BUILDER_ARROW_SPACE + 'px';
                break;
            }
            default: {
                arrow['style'].left = targetOffset.width / bc_location_builder_constants_3.BC_LOCATION_BUILDER_NUMBER_2 - bc_location_builder_constants_1.BC_LOCATION_BUILDER_NUMBER_6 + 'px';
                arrow['style'].top = -bc_location_builder_constants_1.BC_LOCATION_BUILDER_ARROW_SPACE + 'px';
                break;
            }
        }
    };
    BcLocationBuilderPosition.prototype.setElementPosition = function (coachPosition, coachMark, position) {
        var _a;
        var top;
        if (position === 'right' || position === 'left') {
            top = coachPosition.y + common_constants_1.COMMON_CONSTANTS_NUMBERS.N6;
        }
        else {
            top = coachPosition.y;
        }
        coachMark['style'].left = coachPosition.x + 'px';
        coachMark['style'].top = top + 'px';
        coachMark['style'].animation = bc_location_builder_constants_1.BC_LOCATION_BUILDER_ANIMATION_IN;
        (_a = coachMark.scrollIntoView) === null || _a === void 0 ? void 0 : _a.call(coachMark);
    };
    BcLocationBuilderPosition.prototype.getTargetOffset = function (target, localization) {
        return localization.getFullBoundingClientRect(target);
    };
    BcLocationBuilderPosition.prototype.getCoachOffset = function (coach, localization) {
        return localization.getFullBoundingClientRect(coach);
    };
    BcLocationBuilderPosition.prototype.getCoachPosition = function (coachLocalizationBuilder, targetOffset, coachOffset, viewportOffset) {
        return coachLocalizationBuilder.getPosition(targetOffset, coachOffset, viewportOffset);
    };
    return BcLocationBuilderPosition;
}());
exports.BcLocationBuilderPosition = BcLocationBuilderPosition;
